import { render, staticRenderFns } from "./pt-upload-big-file.vue?vue&type=template&id=015c891f&"
import script from "./pt-upload-big-file.vue?vue&type=script&lang=js&"
export * from "./pt-upload-big-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports